import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, takeUntil } from 'rxjs';
import { clearAllState } from '../../../core/store/actions/app.actions';
import { patientSwitchInitiated } from '../../../user/store/actions/user.actions';
import { selectPatientId } from '../../../user/store/selectors/user.selectors';
import { PatientProviderService } from '../../services/patient-care-team/patient-provider.service';
import { getPatientCareTeam, getPatientCareTeamFailure, getPatientCareTeamSuccess } from '../actions/care-team.actions';

@Injectable()
export class CareTeamEffects {
  private actions$ = inject(Actions);
  private patientProviderService = inject(PatientProviderService);
  private store = inject(Store);
  private readonly cancelRequest$ = this.actions$.pipe(ofType(patientSwitchInitiated, clearAllState));

  getPatientCareTeam$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getPatientCareTeam),
      concatLatestFrom(() => [this.store.select(selectPatientId)]),
      mergeMap(([, patientId]) => {
        return this.patientProviderService.getPatientCareTeam(patientId).pipe(
          takeUntil(this.cancelRequest$),
          map(careTeam => {
            return getPatientCareTeamSuccess({ careTeam });
          }),
          catchError(err => {
            return of(getPatientCareTeamFailure({ error: err.error?.errors }));
          })
        );
      })
    );
  });
}
